<template>
  <v-container fluid class="new-appraisal">
    <div class="new-appraisal-content" v-if="steps">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <template>
            <v-stepper-step
              v-for="nq in steps"
              :key="`${nq.step}-step`"
              :complete="e1 > nq.step"
              :step="nq.step"
            >
              <span class="ml-2">{{ nq.label }}</span>
              <v-divider v-if="nq !== steps" :key="nq.step"></v-divider>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="n in steps"
            :key="`${n.step}-content`"
            :step="n.step"
          >
            <div class="content-step1" v-if="n.step == 1">
              <v-text-field
                v-model="step1.name"
                placeholder="Propietario"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.phone"
                placeholder="Telefono"
                type="number"
              ></v-text-field>
              <v-text-field
                v-model="step1.interesado"
                placeholder="V.Interesado"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.entrega"
                placeholder="Entrega inmediata"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="step1.brand"
                placeholder="Marca"
                type="text"
              ></v-text-field>
              <h3>Datos del vehículo</h3>

              <v-text-field
                v-model="step1.model"
                placeholder="Modelo"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.plate"
                placeholder="Matrícula"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.color"
                placeholder="Color"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.kilometers"
                placeholder="Kilómetros"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.engine"
                placeholder="Motor"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.year"
                placeholder="Año"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.itv"
                placeholder="ITV"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="step1.insurance"
                placeholder="Seguro"
                type="text"
              ></v-text-field>

              <v-textarea
                v-model="step1.notes"
                label="Observaciones"
              ></v-textarea>

              <h3>Documentación</h3>
              <v-file-input
                class="mt-5"
                v-model="documentation"
                color="primary"
                counter
                multiple
                placeholder="Documentación del vehículo"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>

                  <span
                    v-else-if="index === 2"
                    class="text-overline grey--text text--darken-3 mx-2"
                  >
                    +{{ documentation.length - 2 }} Archivo(s)
                  </span>
                </template>
              </v-file-input>
            </div>

            <v-btn color="primary" @click="nextStep(n.step)">
              GUARDAR
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { postMethodToken, postMethodTokenDoc } from "@/api-consume/api-calls";
import store from "@/store/index";
export default {
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 3000,
      snackbarColor: "",
      e1: 1,
      steps: [{ label: "Datos no técnicos", step: 1 }],
      step1: {
        name: "",
        phone: "",
        interesado: "",
        commercial_user_id: store.state.userLogged.user_id,
        entrega: "",
        brand: "",
        model: "",
        plate: "",
        color: "",
        kilometers: "",
        engine: "",
        year: "",
        itv: "",
        insurance: "",
        notes: ""
      },
      documentation: []
    };
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },

  methods: {
    async nextStep(n) {
      console.log("N: ", n);
      var options = {};
      var flag = true;
      switch (n) {
        case 1:
          //var check = Object.values(this.step1).includes("");
          var findEmpty = Object.entries(this.step1).filter(
            item => item[1] == ""
          );
          console.log("Vacíos", findEmpty);
          if (
            findEmpty.length > 1 ||
            (findEmpty.length == 1 && findEmpty[0][0] != "notes") ||
            this.documentation.length == 0
          ) {
            this.snackbar = true;
            this.snackbarText = "Complete todos los campos.";
            this.snackbarColor = "red";
            flag = false;
          }
          options = this.step1;
          options.step_1 = 1;
          break;
        case 2:
          options = this.step2;
          options.step_2 = 1;
          options.id = this.responseId;
          break;

        default:
          break;
      }

      if (flag) {
        console.log("ENVÍO: ", options);
        const response = await postMethodToken(
          "/api/appraisal/create",
          options
        );
        console.log("CREAR TASACIÓN: ", response);

        if (response.status == 200) {
          this.responseId = response.data.payload.appraisal.id;
          if (n == 1) {
            console.log(
              "ENVÍO documentacion: ",
              this.responseId,
              this.documentation
            );
            for (let x = 0; x < this.documentation.length; x++) {
              const resp = await postMethodTokenDoc(
                "/api/appraisal/docs/upload",
                this.responseId,
                this.documentation[x]
              );
              console.log("SUBIR DOCUMENTACION: ", resp);
              if (resp.status != 200) {
                this.snackbar = true;
                this.snackbarText = "Error al guardar la documentacion.";
                this.snackbarColor = "red";
                return 0;
              }
            }
          }
          if (n == 2) {
            const opt = {
              appraisal_id: this.responseId,
              image: this.images
            };
            console.log("ENVÍO IMAGES: ", opt);
            const resp = await postMethodToken(
              "/api/appraisal/images/upload",
              opt
            );
            console.log("SUBIR IMAGENES: ", resp);
            if (resp.status != 200) {
              this.snackbar = true;
              this.snackbarText = "Error al guardar las imágenes.";
              this.snackbarColor = "red";
              return 0;
            }
          }
          if (n === this.steps.step) {
            this.e1 = 1;
          } else {
            this.e1 = n + 1;
          }
        } else {
          this.snackbar = true;
          this.snackbarText = "Error al crear la tasación.";
          this.snackbarColor = "red";
        }
      }
    }
  }
};
</script>

<style>
@media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: flex !important;
  }
}
</style>
